import * as React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/rootStore';
import { UserData } from '../types/user';
import useUsers from './useUsers';

const useUsersSearch: () => {
  users: UserData[];
  isSearch: boolean;
  isLoading: boolean;
} = () => {
  const { users, isLoading } = useUsers();
  const search = useSelector((state: RootState) => state.users.userSearch);
  const isSearch = React.useMemo(() => !!(search && search.length), [search]);
  const filteredUsers = React.useMemo(() => {
    if (!isSearch) {
      return users;
    }
    const compare = (value: string) => {
      return value.toLowerCase().includes(search!.toLowerCase());
    };
    return users.filter((user) => {
      return (
        compare(`${user.first_name} ${user.name}`) || compare(`${user.name} ${user.first_name}`) || compare(user.email)
      );
    });
  }, [isSearch, search, users]);

  return { isLoading, users: filteredUsers, isSearch };
};

export default useUsersSearch;
